import PropTypes from "prop-types";

import { t } from "../../../../services";
import { strCode } from "../../../../consts";

import { FeaturesControlWrapper } from "./styled";
import {
  Caption,
  FlexContainers,
  IconButton,
  Paragraph2,
  SVG,
  Switcher,
  WrapperContainer
} from "../../../../components";

const FeaturesControl = ({
  isFeaturesListOpened,
  toggleIsFeaturesListOpened,
  onFeaturesModalOpen,
  onDownload,
  hasFeatures
}) => {
  return (
    <FeaturesControlWrapper isFeaturesListOpened={isFeaturesListOpened}>
      <WrapperContainer Container={FlexContainers.FlexRowBetween}>
        <WrapperContainer>
          <Paragraph2>{t(strCode.CONFIGURATION_TITLE)}</Paragraph2>
          <Caption>
            {isFeaturesListOpened
              ? t(strCode.CONFIGURATION_SETTINGS_HINT)
              : t(strCode.CONFIGURATION_SWITCH_ON_HINT)}
          </Caption>
        </WrapperContainer>

        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={18}>
          <IconButton
            disabled={!isFeaturesListOpened || !hasFeatures}
            tooltipLabel={t(strCode.DOWNLOAD_JSON_TITLE)}
            onClick={onDownload}>
            <SVG.DownloadIcon />
          </IconButton>

          <IconButton
            disabled={!isFeaturesListOpened || !hasFeatures}
            tooltipLabel={t(strCode.CONFIGURE_FEATURES_TITLE)}
            onClick={onFeaturesModalOpen}
            xShift={-10}>
            <SVG.SettingsNavIcon />
          </IconButton>

          <Switcher
            onSwitch={toggleIsFeaturesListOpened}
            checked={isFeaturesListOpened}
            id="features-switcher"
          />
        </WrapperContainer>
      </WrapperContainer>
    </FeaturesControlWrapper>
  );
};

FeaturesControl.propTypes = {
  isFeaturesListOpened: PropTypes.bool.isRequired,
  toggleIsFeaturesListOpened: PropTypes.func.isRequired,
  onFeaturesModalOpen: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  hasFeatures: PropTypes.bool.isRequired
};

export default FeaturesControl;
